"use client";

import { useEffect } from "react";

const WebVitalsReporter = () => {
  useEffect(() => {
    let cancelled = false;

    const loadReporter = async () => {
      const { reportWebVitals } = await import("@/lib/webVitals");
      if (!cancelled) {
        reportWebVitals();
      }
    };

    void loadReporter();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default WebVitalsReporter;
